/*
 * @Author: DouDou
 * @LastEditors: gxd
 * @Date: 2020-09-11 12:16:44
 * @LastEditTime: 2020-11-27 16:56:48
 * @Description: File description
 */
// 老带新V3.2活动规则
export default {
  title: '活动规则',
  content: [
    {
      title: '1.活动时间',
      content: [
        '即日起至2021年1月10日24时'
      ]
    },
    {
      title: '2.参与资格',
      content: [
        '2020年秋季或寒假或春季同步课任何一科购课学员即可参与，以上课程退课后将不能再参与活动。'
      ]
    },
    {
      title: '3.参与规则',
      content: [
        '活动期间，以自然周为周期，生成并分享当周的专属海报，分享至朋友圈保存2小时且在当周上传截图。',
        '分享朋友圈不允许分组或私密，2小时后截图朋友圈，将截图上传至活动页面。工作人员审核通过后，活动奖励将在24小时内到账。',
        '工作人员审核将在2个工作日内完成，请耐心等待；若审核未通过，在当周内审核失败的用户可重复上传截图直到审核成功。当周审核失败且没有及时修改的用户，将无法获得当周奖励。',
        '如果活动期内您没有2020年秋季或寒假或春季同步课订单，将无法继续参与活动。'
      ]
    },
    {
      title: '4.截图教程',
      content: [
        '分享活动海报+邀请语到朋友圈并至少保留2小时，不可分组或私密，2小时后可通过以下方式截图凭证：',
        '打开【微信】-【发现】-【朋友圈】，找到自己分享的朋友圈，截图即可',
        '截图后请在当周内（自然周）尽快上传至活动页面，以免活动过期'
      ]
    },
    {
      title: '5.审核说明',
      content: [
        '审核一般在2个工作日内完成。审核通过后，奖励24小时内到账。审核未通过，可在当周内，重新上传截图。',
        '审核不通过的情况包括但不限于：',
        '·分享海报需加邀请语',
        '·制作专属海报需用自孩子的照片合成海报',
        '·未分享活动指定海报',
        '·朋友圈进行了分组或私密',
        '·朋友圈未保留2小时以上',
        '·上传的截图不完整或有修改、有遮挡',
        '·分享的内容涉及违法违规内容',
        '·分享的内容严重侵犯学而思网校权力'
      ]
    },
    {
      title: '6.奖品兑换说明',
      content: [
        '每周最多可获得1次兑换次数，审核成功后立即获得，活动期间内最多可获得9次兑换次数。',
        '兑换次数用于兑换奖品，按照奖品对应的次数进行兑换。',
        '兑换商品前请填写邮寄地址，兑换成功后不支持退回和修改地址，请谨慎选择。',
        '奖品有任何质量问题都可联系客服进行免费退换，无质量问题不予以退换。',
        '奖品兑换成功后将在15个工作日内进行邮寄，需要发货时间需根据库存情况而定。您可在【学而思网校APP】-【我的】-【查物流】查看物流状态。',
        '本期奖品兑换截止日期为1月13日，1月13日之后兑换次数失效，奖品无法进行兑换。'
      ]
    },
    {
      title: '7.其他说明',
      content: [
        '您上传的活动内容仅用于活动审核，学而思网校将保护您的个人隐私，不会泄露给第三方。',
        '若发现活动期间存在任何违规行为，学而思网校有权取消用户的参与资格并收回奖励。',
        '如有任何活动问题可点击【学而思网校APP】-【我的】-【客户服务】进行咨询。'
      ]
    }
  ]
}
